import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { L10nTranslationModule } from 'angular-l10n';
import { ImageModule } from '@nano/common/image';
import { PaymentModule } from '@nano/payment';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';

import { UserMenuItemsModule } from '../shared/user-menu-items/user-menu-items.module';
import { PaymentMenuItemsComponent } from './payment-menu-items/payment-menu-items.component';
import { NavComponent } from './nav.component';
import { LogoModule } from '../../shared/logo/logo.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    L10nTranslationModule,
    ImageModule,
    PaymentModule,
    NzMenuModule,
    NzDropDownModule,
    NzDrawerModule,
    NzBadgeModule,
    LogoModule,
    UserMenuItemsModule
  ],
  declarations: [NavComponent, PaymentMenuItemsComponent],
  exports: [NavComponent]
})
export class NavModule {}
